import { findTokenMatches, TokenMatch } from './tokens';
import { TokenConfig, TokenDefinition, TokenInstance } from '../types';
import { buildTokenElement } from './token-element';

const renderBetweenMatchText = (
  target: Node,
  value: string,
  cursor: number,
  match: number,
) => {
  if (match <= cursor) return;
  target.appendChild(document.createTextNode(value.slice(cursor, match)));
};

const insertTokenElement = (
  element: Node,
  definition: TokenDefinition,
  match: TokenMatch,
  index: number,
) => {
  const props = definition.render({ index, match: match.text });
  const tokenElement = buildTokenElement(match.key, match.text, props);
  element.appendChild(tokenElement);
  return tokenElement;
};

export const appendTokenizedContent = (
  target: Node,
  content: string,
  config: TokenConfig,
): { tokens: TokenInstance[]; lastTokenElement: HTMLElement | null } => {
  const matches = findTokenMatches(content, config);
  const counter: Record<string, number> = {};
  const tokens: TokenInstance[] = [];
  let lastTokenElement: HTMLElement | null = null;
  let cursor = 0;

  matches.forEach(match => {
    renderBetweenMatchText(target, content, cursor, match.start);
    const index = (counter[match.key] ?? 0) + 1;
    counter[match.key] = index;
    lastTokenElement = insertTokenElement(
      target,
      config[match.key],
      match,
      index,
    );
    tokens.push({ key: match.key, index, match: match.text });
    cursor = match.end;
  });

  renderBetweenMatchText(target, content, cursor, content.length);
  return { tokens, lastTokenElement };
};
